import { render, staticRenderFns } from "./order-success.vue?vue&type=template&id=46a8dc6c"
import script from "./order-success.vue?vue&type=script&lang=ts"
export * from "./order-success.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports